module.exports = __webpack_public_path__ + "assets/img/bf724119d0f660030778216442e613ec.png";